<!-- Header de progresso e navegação de etapas (idêntico ao form) -->
<div class="progress-container">
  <div class="progress-bar">
    <div class="progress-fill" [style.width.%]="getStageProgress()"></div>
  </div>
  <div class="progress-text">{{ currentStage }} de {{ totalStages }}</div>
</div>

<div class="stage-navigation">
  <div
    *ngFor="let stage of [1,2,3,4,5,6]"
    class="stage-item"
    [class.active]="currentStage === stage"
    [class.completed]="currentStage > stage"
    (click)="goToStage(stage)">
    <div class="stage-number">{{ stage }}</div>
    <div class="stage-label">{{ getStageTitle(stage) }}</div>
  </div>
</div>

<div class="stage-content">
  <!-- Stage 1: Dados Pessoais -->
  <div *ngIf="currentStage === 1" class="stage-form">
    <h3>Dados Pessoais</h3>
    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="fullName">Nome Completo</label>
        <input id="fullName" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.fullName">
      </div>
      <div class="form-group">
        <div class="form-check">
          <input type="checkbox" id="isForeigner" class="form-check-input" [disabled]="!isEditMode" [(ngModel)]="form.isForeigner">
          <label class="form-check-label" for="isForeigner">É estrangeiro</label>
        </div>
      </div>
    </div>

    <div *ngIf="!form.isForeigner" class="form-row">
      <div class="form-group">
        <label class="form-label" for="cpf">CPF</label>
        <input id="cpf" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.cpf">
      </div>
      <div class="form-group">
        <label class="form-label" for="rg">RG</label>
        <input id="rg" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.rg">
      </div>
    </div>

    <div *ngIf="form.isForeigner" class="form-row">
      <div class="form-group">
        <label class="form-label" for="passportNumber">Passaporte</label>
        <input id="passportNumber" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.passportNumber">
      </div>
      <div class="form-group">
        <label class="form-label" for="nationality">Nacionalidade</label>
        <input id="nationality" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.nationality">
      </div>
    </div>

    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="birthDate">Nascimento</label>
        <input type="date" id="birthDate" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.birthDate">
      </div>
      <div class="form-group">
        <label class="form-label" for="gender">Gênero</label>
        <select id="gender" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.gender">
          <option value="">Selecione</option>
          <option *ngFor="let option of genderOptions" [value]="option">{{ option }}</option>
        </select>
      </div>
    </div>
  </div>

  <!-- Stage 2: Endereço -->
  <div *ngIf="currentStage === 2" class="stage-form">
    <h3>Endereço</h3>
    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="country">País</label>
        <select id="country" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.country">
          <option value="">Selecione</option>
          <option *ngFor="let c of countries" [value]="c">{{ c }}</option>
        </select>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="street">Rua</label>
        <input id="street" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.street">
      </div>
      <div class="form-group">
        <label class="form-label" for="number">Número</label>
        <input id="number" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.number">
      </div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="neighborhood">Bairro</label>
        <input id="neighborhood" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.neighborhood">
      </div>
      <div class="form-group">
        <label class="form-label" for="city">Cidade</label>
        <input id="city" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.city">
      </div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="state">Estado</label>
        <select id="state" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.state">
          <option value="">Selecione</option>
          <option *ngFor="let s of states" [value]="s">{{ s }}</option>
        </select>
      </div>
      <div class="form-group">
        <label class="form-label" for="zipCode">CEP</label>
        <input id="zipCode" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.zipCode">
      </div>
    </div>
  </div>

  <!-- Stage 3: Contatos -->
  <div *ngIf="currentStage === 3" class="stage-form">
    <h3>Contatos</h3>
    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="primaryPhone">Telefone Principal</label>
        <input id="primaryPhone" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.primaryPhone">
      </div>
      <div class="form-group">
        <label class="form-label" for="secondaryPhone">Telefone Secundário</label>
        <input id="secondaryPhone" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.secondaryPhone">
      </div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="emergencyContactName">Contato de Emergência</label>
        <input id="emergencyContactName" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.emergencyContactName">
      </div>
      <div class="form-group">
        <label class="form-label" for="emergencyContactPhone">Telefone de Emergência</label>
        <input id="emergencyContactPhone" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.emergencyContactPhone">
      </div>
    </div>
  </div>

  <!-- Stage 4: Dados Gerais -->
  <div *ngIf="currentStage === 4" class="stage-form">
    <h3>Dados Gerais</h3>
    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="registration">Matrícula</label>
        <input id="registration" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.registration">
      </div>
      <div class="form-group">
        <label class="form-label" for="position">Cargo</label>
        <input id="position" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.position">
      </div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="department">Departamento</label>
        <input id="department" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.department">
      </div>
      <div class="form-group">
        <label class="form-label" for="manager">Gerente</label>
        <input id="manager" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.manager">
      </div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="costCenter">Centro de Custo</label>
        <input id="costCenter" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.costCenter" placeholder="Ex: TI-01">
      </div>
      <div class="form-group"></div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="hireDate">Admissão</label>
        <input type="date" id="hireDate" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.hireDate">
      </div>
      <div class="form-group">
        <label class="form-label" for="contractType">Tipo de Contrato</label>
        <select id="contractType" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.contractType">
          <option value="">Selecione</option>
          <option *ngFor="let option of contractTypeOptions" [value]="option">{{ option }}</option>
        </select>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <div class="form-check">
          <input type="checkbox" id="inactive" class="form-check-input" [disabled]="!isEditMode" [(ngModel)]="form.inactive">
          <label class="form-check-label" for="inactive">Inativo</label>
        </div>
      </div>
      <div class="form-group">
        <div class="form-check">
          <input type="checkbox" id="blocked" class="form-check-input" [disabled]="!isEditMode" [(ngModel)]="form.blocked">
          <label class="form-check-label" for="blocked">Bloqueado</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Stage 5: Dados Salariais -->
  <div *ngIf="currentStage === 5" class="stage-form">
    <h3>Dados Salariais</h3>
    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="baseSalary">Salário Base</label>
        <input type="number" id="baseSalary" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.baseSalary">
      </div>
      <div class="form-group">
        <label class="form-label" for="grossSalary">Salário Bruto</label>
        <input type="number" id="grossSalary" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.grossSalary">
      </div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="netSalary">Salário Líquido</label>
        <input type="number" id="netSalary" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.netSalary">
      </div>
      <div class="form-group">
        <label class="form-label" for="salaryType">Tipo de Salário</label>
        <select id="salaryType" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.salaryType">
          <option value="">Selecione</option>
          <option *ngFor="let option of salaryTypeOptions" [value]="option">{{ option }}</option>
        </select>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="lastSalaryUpdate">Última Atualização</label>
        <input type="date" id="lastSalaryUpdate" class="form-control" [disabled]="!isEditMode" [(ngModel)]="form.lastSalaryUpdate">
      </div>
    </div>
    <div class="form-row">
      <div class="form-group full-width">
        <label class="form-label" for="salaryNotes">Observações</label>
        <textarea id="salaryNotes" class="form-control" rows="3" [disabled]="!isEditMode" [(ngModel)]="form.salaryNotes"></textarea>
      </div>
    </div>
  </div>

  <!-- Stage 6: Documentos (somente leitura) -->
  <div *ngIf="currentStage === 6" class="stage-form">
    <h3>Documentos</h3>
    <div class="form-row">
      <div class="form-group">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" [checked]="form.cnhDocumentUploaded" disabled>
          <label class="form-check-label">CNH/Documento com foto</label>
        </div>
      </div>
      <div class="form-group">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" [checked]="form.residenceProofUploaded" disabled>
          <label class="form-check-label">Comprovante de residência</label>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" [checked]="form.workCardUploaded" disabled>
          <label class="form-check-label">Carteira de trabalho</label>
        </div>
      </div>
      <div class="form-group">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" [checked]="form.curriculoDocumentUploaded" disabled>
          <label class="form-check-label">Currículo</label>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Ações de etapa -->
<div class="stage-actions">
  <button class="btn btn-secondary" (click)="previousStage()" [disabled]="currentStage === 1">
    <i class="fas fa-arrow-left"></i>
    Anterior
  </button>

  <button *ngIf="currentStage < totalStages" class="btn btn-primary" (click)="nextStage()">
    Próximo
    <i class="fas fa-arrow-right"></i>
  </button>

  <button *ngIf="currentStage === totalStages" class="btn btn-success" [disabled]="!isEditMode">
    <i class="fas fa-save"></i>
    Salvar Alterações
  </button>
</div>

